export default __webpack_public_path__ + "static/media/x33-logo-mooncake.ece0ba60.png";